<template>
    <div class="delayTimer">
        <DropdownMenu :buttonClass="['base', 'btnDelay']" :buttonArrowSVG="true" >
            <template v-slot:button>
                <i class="fas fa-history"></i>
                {{ inputDelay }} Seg
            </template>
            <template  #menu="{ closeMenu }">
                <ul style="margin: 0; padding: 0; list-style: none">
                    <li>
                        <button @click="changeDelayAndClose(3, closeMenu)">
                            3s Delay
                        </button>
                    </li>
                    <li>
                        <button @click="changeDelayAndClose(5, closeMenu)">
                            5s Delay
                        </button>
                    </li>
                    <li>
                        <button @click="changeDelayAndClose(10, closeMenu)">
                            10s Delay
                        </button>
                    </li>
                </ul>
            </template>
        </DropdownMenu>
    </div>
</template>
<script>
import DropdownMenu from '@/core/components/DropdownMenu.vue'
export default {
    components: {
        DropdownMenu
    },
    name: "delayTimer",
    props: {
        delay: {
            type: [Number, String],
            default: 0,
        },
        eventData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            inputDelay: this.delay
        }
    },
    methods: {
        changeDelayAndClose(newDelay, closeMenu) {
            this.inputDelay = newDelay;
            this.$emit('update-delay', this.eventData.id, newDelay);
            // if (typeof closeMenu === 'function') closeMenu();
            // else console.warn('No se pudo cerrar el dropdown', typeof closeMenu);
			// @ts-ignore
			window.master.post('bRem/setUpdateField', {
				org_id: this.org_id,
				user_id: this.user_id,
				event_id: this.eventData.id,
				field_input: 'delay_timer',
				field_value: newDelay,
			})
			.then((response) => {
				// t.is_loading = false;
				console.log('bRem loaded', response.data);
				// this.getbRem();
			}).catch((error) => {
				// t.is_loading = false;
				console.log(error);
			});
        },
        handleMenuSelect(option) {
            // handle closeDown event if needed
            // console.log('Seleccionaste:', option);
        }
    }
};
</script>
<style lang="scss">
.delayTimer
{
    button.base.btnDelay {
        border: 1px solid rgba(0, 0, 0, 0.25);
        padding: 3px 5px;
        border-radius: 1px;
    }
    .dropdown_menu ul li button {
        display: flex;
        align-items: center;
        gap: 5px;
        width: 100%;
        padding: 5px 5px;
        padding-left: 10px;
        font-size: 14px;
    }
}
</style>
